import PropTypes from 'prop-types';
import { ProductPriceBlock } from '@codex/basics';
import { getTranslation } from '../../translations/translations';

const ProductItemPriceBlock = ({ defaultChannelsAvailability, isFlashSale, displayWasPriceRange, price, variant }) => {

  const isOutOfStock =
    defaultChannelsAvailability.showEmailMeBack ||
    (typeof defaultChannelsAvailability.delivery !== 'undefined' &&
      defaultChannelsAvailability.delivery.type === 'homeDeliveryUnavailable' &&
      typeof defaultChannelsAvailability.inStore !== 'undefined' &&
      defaultChannelsAvailability.inStore.type === 'collectInStoreUnavailable'
    );

  return (
    <ProductPriceBlock
      outOfStock={isOutOfStock}
      isFlashSale={isFlashSale}
      displayWasPriceRange={displayWasPriceRange}
      currentPrice={price.currentPrice}
      savingsPrice={price.savingsPrice
        ? `${getTranslation('savingsPriceTranslation')} ${price.savingsPrice}`
        : undefined}
      wasPrice={price.wasPrice
        ? `${getTranslation('wasPriceTranslation')} ${price.wasPrice}`
        : undefined}
      wasPriceFrom={price.wasPriceFrom}
      wasPriceTo={price.wasPriceTo}
      variant={variant}
      mainProductWasPriceTranslation={getTranslation('mainProductWasPriceTranslation')}
      webExclusivePriceTranslation={getTranslation('webExclusivePriceTranslation')}
      perMonthTranslation={getTranslation('perMonthTranslation')}
      fromDateTranslation={getTranslation('fromDateTranslation')}
      toDateTranslation={getTranslation('toDateTranslation')}
    />
  );
};

ProductItemPriceBlock.propTypes = {
  defaultChannelsAvailability: PropTypes.shape({
    canBeDownloaded: PropTypes.bool,
    showEmailMeBack: PropTypes.bool,
    delivery: PropTypes.shape({
      type: PropTypes.string
    }),
    inStore: PropTypes.shape({
      type: PropTypes.string
    })
  }).isRequired,
  isFlashSale: PropTypes.bool.isRequired,
  price: PropTypes.shape({
    currentPrice: PropTypes.string.isRequired,
    savingsPrice: PropTypes.string,
    wasPrice: PropTypes.string,
    wasPriceFrom: PropTypes.string,
    wasPriceTo: PropTypes.string
  }).isRequired,
  variant: PropTypes.oneOf(['listing_grid', 'listing_list']).isRequired,
  displayWasPriceRange: PropTypes.bool
};

ProductItemPriceBlock.defaultProps = {
  displayWasPriceRange: false
};

export default ProductItemPriceBlock;
